import React, { useContext, useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import toast from '../../utils/helpers';
import Button from '../../Components/Button/Button';
import ImageSlider from '../../Components/ImageSlider/ImageSlider';
import Loader from '../../Components/Loader/Loader';
import Quantity from '../../Components/Quantity/Quantity';
import Size from '../../Components/Size/Size';
import { CartContext } from '../../Context/CartContext/CartContext';
import { ADD_PRODUCT } from '../../Context/Reducers/cartReducer';
import useFetch from '../../Hooks/useFetch';
import styles from './ProductDetails.module.scss';

const ProductDetails = () => {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const handleQtyAdd = () => setQuantity(quantity + 1);
  const handleQtyDeduct = () => setQuantity((prevQty) => (prevQty > 0 ? quantity - 1 : quantity));
  const {
    state: {
      title, price, description, image,
    },
    loading,
  } = useFetch(`${process.env.REACT_APP_BASE_URL}/products/${id}`);

  const { dispatch } = useContext(CartContext);
  const addProduct = () => {
    dispatch({
      type: ADD_PRODUCT,
      payload: {
        product: {
          id,
          title,
          price,
          image,
          description,
        },
        quantity,
      },
    });
    toast('Added product to the cart');
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.productDetailsContainer}>
          <ImageSlider />
          <div className={styles.productDetails}>
            <div className={styles.productTitle}>{title}</div>
            <div className={styles.productPrice}>{`₹ ${price}`}</div>
            <div className={styles.productDesc}>{description}</div>
            <Size />
            <Quantity
              quantity={quantity}
              handleQtyAdd={handleQtyAdd}
              handleQtyDeduct={handleQtyDeduct}
              disableTitle
            />
            <div className={styles.productAddButton}>
              <Button width="10vw" onClick={addProduct}>
                <div className={styles.buttonContent}>
                  <div className={styles.buttonIcon}>
                    <FaShoppingCart />
                  </div>
                  Add to cart
                </div>
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetails;
